<template>
  <div class="cart-free-tips">
    <div v-if="freeShippingOnOff.agio > 0" class="cart-free-tips--fail">
      <p class="note">
        {{$t('cart.free_shipping_tips', { free_value: `${ getSymbolFromCurrency($store.state.pricetype)}${computePrice(freeShippingOnOff.agio, true, $store.state.pricetype)}` })}}
      </p>
      <div class="process" v-if="freeShippingOnOff.freeProcessOnOff">
        <span :style="{ width: freeShippingOnOff.percentage + '%' }"></span>
      </div>
    </div>
    <div class="cart-free-tips--success" v-else>{{$t('cart.free_shipping')}}</div>
  </div>
</template>
<script>
import getSymbolFromCurrency from 'currency-symbol-map'
export default {
  props: {
    freeShippingOnOff: {},
  },
  data() {
    return {
      getSymbolFromCurrency: '',
    }
  },
  beforeMount() {
    this.getSymbolFromCurrency = getSymbolFromCurrency
  },
}
</script>
<style scoped lang='scss'>
.cart-free-tips {
  line-height: 1;
  &--fail {
    .process {
      position: relative;
      width: 100%;
      height: 8px;
      margin-top: 8px;
      border: 1px solid #f2f2f2;
      & > span {
        position: absolute;
        display: inline-block;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #aaa;
      }
    }
  }
}
</style>